import { Route, Switch, useLocation } from 'react-router-dom'
import { routes } from '.'
import { getTokensFromLocalStorage } from '../api/auth'
import LoginView from '../app/login/LoginView'
import Business from './Business'
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RoutesProps {}

const Routes = (props: RoutesProps) => {
  const tokens = getTokensFromLocalStorage()
  const { search } = useLocation()
  const values = new URLSearchParams(search)
  const sessionId = values.get('sessionId')

  return (
    <Switch>
      {tokens && <Route path={routes.root.BUSINESS} component={Business} />}
      {sessionId && tokens && tokens.expires > Date.now() && (
        <Route path={routes.root.OAUTH} component={Business} />
      )}
      {sessionId && (
        <Route
          path={routes.root.OAUTH}
          render={() => <LoginView sessionId={sessionId} />}
        />
      )}
      {(!tokens || (tokens && tokens.expires < Date.now())) && (
        <Route path={routes.root.LOGIN} component={LoginView} />
      )}
      <Route path={routes.root.LOGIN} component={LoginView} />
    </Switch>
  )
}

export default Routes
